var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getEndPointUrl } from "@utils";
const SERVICE = 'QueryEngine';
const v1 = (path) => `/v1${path}`;
function request(context, route, method, data, params) {
    return context.uxpContext.executeMicroServiceSafe({
        serviceName: SERVICE,
        route,
        method,
        data,
        params
    });
}
export function checkStatus(context) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const result = yield request(context, '/status', 'get');
        if (result.error) {
            console.log('QUERY_ENGINE_IS_DOWN:', result.errorMessage);
            return {
                active: false,
                details: null
            };
        }
        return {
            active: !!result.data && !!((_a = result.data) === null || _a === void 0 ? void 0 : _a.msg),
            details: ((_b = result.data) === null || _b === void 0 ? void 0 : _b.details) || null
        };
    });
}
export function getAvailableSources(context) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield request(context, v1('/catalog'), 'get');
        if (result.error) {
            console.error('Error fetching available sources:', result.errorMessage);
            return {
                definitions: [],
                relationships: []
            };
        }
        return result.data;
    });
}
export function getAvailableSourcesForHistoricalData(context) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield request(context, v1('/catalog/history'), 'get');
        if (result.error) {
            console.error('Error fetching available sources for historical data:', result.errorMessage);
            return {
                definitions: [],
                relationships: []
            };
        }
        return result.data;
    });
}
export function getQueryDataSource(context, queryId) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield request(context, v1(`/catalog/query/${queryId}`), 'get');
        if (result.error) {
            console.error('Unable to get query source. Error:', result.errorMessage);
            return null;
        }
        return result.data;
    });
}
const SchemaCache = {};
export function getSchema(context, query) {
    return __awaiter(this, void 0, void 0, function* () {
        const key = JSON.stringify(query);
        if (SchemaCache[key]) {
            const time = SchemaCache[key].time;
            if (Number(new Date()) - Number(time) < 1000 * 30) {
                console.log('Returning cached schema', query, SchemaCache);
                return SchemaCache[key].data;
            }
        }
        const result = yield request(context, v1('/schema'), 'post', Object.assign({}, query));
        if (result.error) {
            console.error('Error fetching schema:', result.errorMessage);
            return [];
        }
        SchemaCache[key] = {
            time: new Date(),
            data: result.data
        };
        return result.data;
    });
}
export function executeQuery(context, query, params) {
    return __awaiter(this, void 0, void 0, function* () {
        return request(context, v1('/execution'), 'post', query, params || {});
    });
}
export function exportQuery(context, query) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield request(context, v1('/execution'), 'post', query, {
            format: 'csv',
            mode: 'preview'
        });
        if (result.error)
            throw new Error(result.errorMessage);
        return result.data;
    });
}
/** Streams the query result as a CSV file download via the browser. */
export function exportCsv(context, query) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const url = getEndPointUrl(context, '/v1/execution?format=csv');
            const response = yield fetch(url, {
                method: 'POST',
                body: JSON.stringify(query),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `APIKEY ${context === null || context === void 0 ? void 0 : context.uxpContext.apiKey}`
                }
            });
            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
            const reader = response.body.getReader();
            const stream = new ReadableStream({
                start(controller) {
                    function push() {
                        reader.read().then(({ done, value }) => {
                            console.log('STREAMING', value === null || value === void 0 ? void 0 : value.length, value);
                            if (done) {
                                controller.close();
                                return;
                            }
                            controller.enqueue(value);
                            push();
                        }).catch(error => {
                            console.error('Stream error:', error);
                            controller.error(error);
                        });
                    }
                    push();
                }
            });
            const blob = yield new Response(stream).blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = 'data.csv';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(downloadUrl);
            document.body.removeChild(a);
        }
        catch (error) {
            console.error('There was a problem with the streaming download operation:', error);
            throw error;
        }
    });
}
export function getCustomTransformation(context, description) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield request(context, v1('/ai/custom-transform'), 'post', {
            description
        });
        if (result.error)
            throw new Error(result.errorMessage);
        return result.data;
    });
}
export function applyCopilot(context, query, description) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield request(context, v1('/ai/copilot'), 'post', query, {
            question: description
        });
        if (result.error)
            throw new Error(result.errorMessage);
        return result.data;
    });
}
export function askQuestion(context, question) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield request(context, v1('/ai/question'), 'get', undefined, {
            question
        });
        if (result.error)
            throw new Error(result.errorMessage);
        return result.data;
    });
}
export function getSampleQuestions(context) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield request(context, v1('/ai/samples'), 'get');
        if (result.error) {
            console.error('Error fetching sample questions:', result.errorMessage);
            return [];
        }
        return result.data;
    });
}
export function aiSearch(context, request_) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield request(context, v1('/ai/search'), 'post', request_);
        if (result.error)
            throw new Error(result.errorMessage);
        return result.data;
    });
}
export function resetConfig(context) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield request(context, '/config/reset', 'post');
        if (result.error)
            throw new Error(result.errorMessage);
        return result.data;
    });
}
